import { Entry, validateEntry } from "../entry/Entry.js";
import { Item, validateItem } from "../item/Item.js";
import {
  createObjectValidator,
  validateNumber,
  validateString
} from "../../../../packages/validator/validator.js";

/**
 * Represents one query item for the Query interface.
 */
export type QueryItem = {
  /**
   * Composite ID from entry ID and item index.
   */
  id: string;
  /**
   * Underlying item.
   */
  item: Item;
  /**
   * Associated entry where this item occurs in.
   */
  entry: Entry;
  /**
   * Index of the item in the entry items array.
   */
  itemIndex: number;
};

export const validateQueryItem = createObjectValidator<QueryItem>("QueryItem", {
  id: validateString,
  item: validateItem,
  entry: validateEntry,
  itemIndex: validateNumber
});
